const context = require.context('@/pages', true, /.*main.js/);
export const routes = context.keys().map((filename) => {
  return context(filename).default;
});
